<template>
  <label
    :class="labelClasses"
    @click="layerChanged"
    :style="labelStyles"
  >
    <input
      type="radio"
      name="layerOption"
      :id="id"
      autocomplete="off"
      :checked="checked"
    >
    {{ name }}
  </label>
</template>

<script>
import EventBus from '@/eventBus';

export default {
  computed: {
    labelClasses() {
      const classes = [
        'btn',
        'btn-sm',
        'btn-outline',
      ];
      if (this.checked) {
        classes.push('active');
      }
      return classes;
    },
    labelStyles() {
      return {
        backgroundColor: this.checkedData ? this.color : '#FFF',
        borderColor: this.color,
        color: this.checkedData ? '#FFF' : this.color,
      };
    },
  },
  data() {
    return {
      checkedData: this.checked,
    };
  },
  name: 'Layer',
  props: {
    checked: {
      required: true,
      type: Boolean,
    },
    color: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    wmsLayer: {
      required: true,
      type: String,
    },
  },
  methods: {
    layerChanged() {
      EventBus.$emit('layer-changed', this.wmsLayer);
    },
  },
  watch: {
    checked(newV) {
      this.checkedData = newV;
    },
  },
};
</script>

<style>
</style>
